import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Edit, Trash2 } from "react-feather";
import { PlusCircle } from 'feather-icons-react/build/IconComponents';
import { Table } from "antd";
import Swal from "sweetalert2";
import { useSelector } from 'react-redux';
import withReactContent from "sweetalert2-react-content";
import AddRole from "../../core/modals/usermanagement/addrole.jsx";
import EditRole from "../../core/modals/usermanagement/editrole.jsx";
// import { useSelector } from "react-redux";

import { APIgetRoles, APIDeleteRole } from "../../api/settings.ts";

const StoreList = () => {
  const translation = useSelector(state => state.root.translation);

  const [dataRole, setDataRole] = useState([]);
  const [editRole, setEditRole] = useState({});
  const [loading, setLoading] = useState(false);

  const MySwal = withReactContent(Swal);

  const fetchRoles = async () => {
   setLoading(true);
    try {
      const res = await APIgetRoles({});
      if (res?.response?.roles) {
        setDataRole(res.response.roles.reverse());
      }
    } catch (error) {
      console.error("Error fetching roles:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (e,record) => {
    e.preventDefault();
    console.log('handleEdit record',record);
    if(record)
      setEditRole(record);
  };

  const handleDelete = async (e,record) => {
    e.preventDefault();
    try {
      const result = await MySwal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00ff00",
        confirmButtonText: "Yes, delete it!",
        cancelButtonColor: "#ff0000",
        cancelButtonText: "Cancel",
      });

      if (result.isConfirmed) {
        const res = await APIDeleteRole({ id: record._id });
        if (res) {
          await MySwal.fire({
            title: "Deleted!",
            text: "Role has been deleted.",
            icon: "success",
            confirmButtonText: "OK",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
          fetchRoles();
        } else {
          throw new Error("Deletion failed");
        }
      }
    } catch (error) {
      await MySwal.fire({
        title: "Error!",
        text: error.message || "An error occurred while deleting the role.",
        icon: "error",
        confirmButtonText: "OK",
        customClass: {
          confirmButton: "btn btn-danger",
        },
      });
    }
  };
  //Permissions  
  const permissions = useSelector(state => state.root.permissions) || [];
  const roleTitle = useSelector(state => state.root.roleTitle) || '';
  const roleTitleAdmin = useSelector(state => state.root.roleTitleAdmin) || '';

  const canView = roleTitle === roleTitleAdmin || permissions.some(p => p.Module.toLowerCase() === 'roles-permissions' && p.Permission.toLowerCase() === 'view');
  const canCreate = roleTitle === roleTitleAdmin || permissions.some(p => p.Module.toLowerCase() === 'roles-permissions' && p.Permission.toLowerCase() === 'create');
  const canUpdate = roleTitle === roleTitleAdmin || permissions.some(p => p.Module.toLowerCase() === 'roles-permissions' && p.Permission.toLowerCase() === 'update');
  const canDelete = roleTitle === roleTitleAdmin || permissions.some(p => p.Module.toLowerCase() === 'roles-permissions' && p.Permission.toLowerCase() === 'delete');

  const columns = [
    {
      title: translation?.role_name || 'Role Name',
      dataIndex: "title",
      sorter: (a, b) => a.title.localeCompare(b.title),
    },
    {
      title: translation?.description || "Description",
      dataIndex: "description",
      sorter: (a, b) => a.description.localeCompare(b.description),
    },
    {
      title: translation?.actions || "Actions",
      dataIndex: "action",
      render: (text, record) => (
        <div className="action-table-data">
          <div className="edit-delete-action">
          {canUpdate && record.title != 'TenantAdmin' && (
            <Link
              className="me-2 p-2"
              to="#"
              data-bs-toggle="modal"
              data-bs-target="#add-units"
              onClick={(e) => handleEdit(e,record)}
            >
              <Edit className="feather-edit" />
            </Link>
             )}
            {canDelete && record.title != 'TenantAdmin' && (
            <Link
              className="confirm-text p-2"
              to="#"
              onClick={(e) => handleDelete(e,record)}
            >
              <Trash2 className="feather-trash-2" />
            </Link>
              )}
          </div>
        </div>
      ),
    },
  ];

  useEffect(() => {
    fetchRoles();
  }, []);

  const handleAddRoleClick = () => {
    setEditRole({}); // Reset editRole when adding a new role
  };
  if (loading) {
    return (
      <div className="page-wrapper dashboard-wrapper">
        <div className="dashboard-content loader-content">
          <div id="global-loader">
            <div className="whirly-loader"></div>
          </div>
        </div>
      </div>
    );
  }
  return (
    <div>
        <div className="page-wrapper">
           {canView ? (
        <div className="content">
<div className="page-header">
            <div className="add-item d-flex">
                <div className="page-title">
                    <h4>{translation?.roles_permissions || "Roles & Permissions"}</h4>
                    <h6>{translation?.["manageyourroles&permissions"] || "Manage Your Roles & Permissions"}</h6>
                </div>
            </div>
        
          {canCreate ? (
          <div className="page-btn">
          <Link
              to="#"
              className="btn btn-primary"
              data-bs-toggle="modal"
              data-bs-target="#add-roles"
              
          >
              <PlusCircle className="me-2" onClick={handleAddRoleClick}/>
               {translation?.add_role || "Add Role"}
          </Link>
          </div>

        ) : null}
        </div>
        <div className="card table-list-card">
          <div className="card-body">
            <div className="table-responsive">
              <Table
                className="table datanew"
                columns={columns}
                dataSource={dataRole}
                rowKey={(record) => record._id || record.id}
              />
            </div>
          </div>
        </div>
      </div>
        ) : (
          <div className="page-wrapper">
              <div className="content">
                  <p>{translation?.you_do_not_have_permission_to_view_this_page || "You do not have permission to view this page."}</p>
              </div>
          </div>
      )}
      
       {editRole && (
        canView && <EditRole edit={editRole} refetchRole={fetchRoles} /> 
      )}
      {
        <AddRole refetchRole={fetchRoles} /> 
      }
      </div>
    </div>
  );
};

export default StoreList;
